export default __webpack_public_path__ + "static/media/services_1500_2.20aed6f2.png";